<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Assistance MMS</div>
</div>

@if (step == 1) {
    <div class="col-12 w-100 text-center">
        Avez-vous éteint et rallumé votre téléphone?
        <br/><br/>
        <div class="cta_container">
            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            <button type="button" class="cta_btn level_2 column" (click)="setStep(2)">Valider<span></span></button>
        </div>
    </div>
}

@if (step == 2) {
    <div class="row w-100 pt-3">
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left w-100">
                Les données cellulaires sont-elles actives sur votre mobile ?<br/>
                NB: Si vous avez le symbole H/H+, E ou 3G affiché près de vos barres réseau, alors les données cellulaires sont bien actives, sinon merci de vérifier les paramètres réseau de votre mobile.
            </span>
            <div class="col-auto ml-2">
                <input type="radio" class="form-check-input" name="activeCellularData" [(ngModel)]="activeCellularData"
                       value="1"/>
                <label class="form-check-label">
                    Oui
                </label>
            </div>
            <div class="col-auto">
                <input type="radio" class="form-check-input" name="activeCellularData" [(ngModel)]="activeCellularData"
                       value="0"/>
                <label class="form-check-label">
                    Non
                </label>
            </div>
        </div>
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left w-100">Saisissez les informations de votre téléphone. L'imei s'obtient en composant le *#06#</span>
            IMEI : <input type="number" min="0" class="form-control" [(ngModel)]="imeiPhone">
            @if (errorImeiPhone) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
            Marque : <input type="text" class="form-control" [(ngModel)]="brandPhone">
            @if (errorBrandPhone) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
            Modèle : <input type="text" class="form-control" [(ngModel)]="modelPhone">
            @if (errorModelPhone) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
        </div>
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left w-100">Système d'exploitation</span>
            <div class="col-auto ml-2">
                <input type="radio" class="form-check-input" name="system" [(ngModel)]="system" value="iOS"/>
                <label class="form-check-label">
                    iOS
                </label>
            </div>
            <div class="col-auto">
                <input type="radio" class="form-check-input" name="system" [(ngModel)]="system" value="Android"/>
                <label class="form-check-label">
                    Android
                </label>
            </div>
            <div class="col-auto">
                <input type="radio" class="form-check-input" name="system" [(ngModel)]="system" value="Autre"/>
                <label class="form-check-label">
                    Autre
                </label>
            </div>
            @if (system == 'Android') {
                <div class="row w-100 ml-3">
                    Version ? <input type="text" class="form-control" [(ngModel)]="androidVersion">
                    @if (errorAndroidVersion) {
                        <p class="error-message w-100">Ce champ est invalide</p>
                    }
                </div>
            }
            @if (system == 'Autre') {
                <div class="row w-100 ml-3">
                    Lequel ? <input type="text" class="form-control" [(ngModel)]="otherSystem">
                    @if (errorOtherSystem) {
                        <p class="error-message w-100">Ce champ est invalide</p>
                    }
                </div>
            }
        </div>
        <div class="col-12 w-100 text-center cta_container">
            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
        </div>
    </div>
}
